import gql from 'graphql-tag';

export default gql`
    mutation RemoveImageFromALoad($input: RemoveImageFromALoadInput) {
        removeImageFromALoad(input: $input) {
            errors
        }
    }
`;
